<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Warehouse.Statistics')"
      width="320px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="left"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('Warehouse.Number')"
                    prop="warehouseNo"
                  >
                    <el-input v-model="page.number" no="number" :disabled="true" />
                  </el-form-item>

                  <el-form-item
                    :label="$t('Warehouse.QuantityActual')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="page.quantity" no="quantity" :disabled="true" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WeightActual')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="page.weight" no="weight" :disabled="true" />
                  </el-form-item>

                  <el-form-item
                    :label="$t('Warehouse.CubageActual')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="page.cubage" no="cubage" :disabled="true" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="spacing" />
        <div class="triggers" align="right">
          <el-button no="cancel" type="primary" @click="cancel">
            {{ $t('common.btn.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'WarehouseStatisticsWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    warehousesList: { type: Array, required: false }
  },
  data() {
    return {
      loading: false,
      page: {
        number: '0',
        quantity: '0',
        weight: '0.00',
        cubage: '0.000'
      }
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {
    this.onShow()
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    onShow() {
      if (!this.warehousesList) {
        return
      }

      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const key in this.warehousesList) {
        const warehouseIn = this.warehousesList[key]
        quantity += warehouseIn.quantitySum
        weight += warehouseIn.weightSum
        cubage += warehouseIn.cubageSum
      }
      this.page.number = ColumnUtils.formatNumber(this.warehousesList.length, 0, false, false, true)
      this.page.quantity = ColumnUtils.formatNumber(quantity, 0, false, false, true)
      this.page.weight = ColumnUtils.formatNumber(weight, 2, false, false, true)
      this.page.cubage = ColumnUtils.formatNumber(cubage, 3, false, false, true)
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

